import { render, staticRenderFns } from "./RoundOverall.vue?vue&type=template&id=ae068046&scoped=true&"
import script from "./RoundOverall.vue?vue&type=script&lang=js&"
export * from "./RoundOverall.vue?vue&type=script&lang=js&"
import style0 from "./RoundOverall.vue?vue&type=style&index=0&id=ae068046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae068046",
  null
  
)

export default component.exports